export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10158.270a27ad.jpg";